<form [formGroup]="paymentDocumentTypeForm">
  <div class="field mb-4">
    <!-- Start::title -->
    <span class="text-900 text-2xl block font-semibold mb-5"
      >¿Qué tipo de documento deseas?</span
    >
    <!-- End::title -->

    <!-- Start::recipient type -->
    <div class="flex flex-column lg:flex-row field p-0 gap-3">
      @for(type of paymentDocumentTypes; track $index){
      <div
        class="flex p-3 border-round border-1 surface-border w-full cursor-pointer flex align-items-center h-6rem"
        [ngClass]="{
          'surface-border hover:border-400':
            paymentDocumentTypeField?.value !== type.value,
          'border-primary bg-blue-50':
            paymentDocumentTypeField?.value === type.value
        }"
        (click)="onSelectPaymentDocumentType(type.value)"
      >
        <p-radioButton
          name="documentType"
          [value]="type.value"
          formControlName="documentType"
          styleClass="mr-3"
        />
        <div class="mr-4 md:mr-6">
          <div class="font-semibold">{{ type.title }}</div>
        </div>
      </div>
      }
    </div>
  </div>
</form>
